import { BaseModel } from './base';

export class Comment extends BaseModel {
  replyId?: string;
  description: string;
  userId: string;
  createdAt: Date;
  updatedAt: Date;
  recievers: [];
  subscriberId: string;
  siteId: string;
  targetId: string;
}
